"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcListRowQuerySelectors = exports.BcListRowAriaLabels = exports.BcListRowConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcListRowConstants = (function (_super) {
    __extends(BcListRowConstants, _super);
    function BcListRowConstants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BcListRowConstants.LIST_ROW_LAST_ITEMS = common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
    BcListRowConstants.LIST_ROW_MAX_NUMBER = common_constants_1.COMMON_CONSTANTS_NUMBERS.N5;
    BcListRowConstants.LIST_ROW_SEPARATION_MOBILE = common_constants_1.COMMON_CONSTANTS_NUMBERS.N8;
    BcListRowConstants.ZERO = common_constants_1.COMMON_CONSTANTS_NUMBERS.N0;
    BcListRowConstants.FIRST_POSITION = common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
    BcListRowConstants.TWO_PRIMARY_ELEMENTS = common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
    BcListRowConstants.DOUBLE = common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
    BcListRowConstants.LIST_COLUMN = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-list-column");
    BcListRowConstants.LIST_COLUMN_ACTION = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-list-column-action");
    BcListRowConstants.LIST_COLUMN_ACTION_CHECKBOX = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-list-column-action-checkbox");
    BcListRowConstants.LIST_COLUMN_CONTENT = BcListRowConstants.LIST_COLUMN + '-content';
    BcListRowConstants.LIST_COLUMN_CONTENT_DATA = BcListRowConstants.LIST_COLUMN + '-content-data';
    BcListRowConstants.LIST_COLUMN_CONTENT_DATA_TEXT_SHRINKABLE = "".concat(BcListRowConstants.LIST_COLUMN_CONTENT_DATA, "-text-shrinkable");
    BcListRowConstants.LIST_COLUMN_CONTENT_PRIMARY = "".concat(BcListRowConstants.LIST_COLUMN_CONTENT, "-primary");
    BcListRowConstants.LIST_COLUMN_HIDE_EXTRA_COLUMN = BcListRowConstants.LIST_COLUMN + '-hide-extra-column';
    BcListRowConstants.LIST_COLUMN_MENU = BcListRowConstants.LIST_COLUMN + '-menu';
    BcListRowConstants.LIST_COLUMN_ORDER = BcListRowConstants.LIST_COLUMN + '-order';
    BcListRowConstants.LIST_COLUMN_LEFT_MOBILE_POSITION = BcListRowConstants.LIST_COLUMN + '-left-mobile-position';
    BcListRowConstants.LIST_ROW = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-list-row");
    BcListRowConstants.LIST_ROW_ACTION_ICON = BcListRowConstants.LIST_ROW + '-action-icon';
    BcListRowConstants.LIST_ROW_CHECKBOX = BcListRowConstants.LIST_ROW + '-checkbox';
    BcListRowConstants.LIST_ROW_CHECKBOX_SELECTED = "".concat(BcListRowConstants.LIST_ROW_CHECKBOX, "-selected");
    BcListRowConstants.LIST_ROW_CONTAINER_CHECKBOX = BcListRowConstants.LIST_ROW + '-container-checkbox';
    BcListRowConstants.LIST_ROW_CONTENT = BcListRowConstants.LIST_ROW + '-content';
    BcListRowConstants.LIST_ROW_CONTENT_DATA = BcListRowConstants.LIST_ROW + '-content-data';
    BcListRowConstants.LIST_ROW_MAIN_CONTENT = BcListRowConstants.LIST_ROW + '-main-content';
    BcListRowConstants.LIST_ROW_NUMBER_0 = "".concat(BcListRowConstants.ZERO);
    BcListRowConstants.LIST_ROW_NUMBER_1 = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N1);
    BcListRowConstants.LIST_ROW_NUMBER_2 = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
    BcListRowConstants.LIST_ROW_NUMBER_3 = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N3);
    BcListRowConstants.LIST_ROW_NUMBER_4 = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N4);
    BcListRowConstants.LIST_ROW_NUMBER_5 = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N5);
    BcListRowConstants.LIST_ROW_NUMBER_6 = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N6);
    BcListRowConstants.LIST_ROW_RADIOBUTTON = BcListRowConstants.LIST_ROW + '-radiobutton';
    BcListRowConstants.LIST_ROW_RADIOBUTTON_SELECTED = "".concat(BcListRowConstants.LIST_ROW_RADIOBUTTON, "-selected");
    BcListRowConstants.LIST_ROW_TABLE = "".concat(BcListRowConstants.LIST_ROW, "-table");
    BcListRowConstants.LIST_ROW_TITLE = "".concat(BcListRowConstants.LIST_ROW, "-title");
    BcListRowConstants.TABLE_SMALL_BREAK_POINT = '576';
    BcListRowConstants.TABINDEX = 'tabindex';
    BcListRowConstants.HEIGHT = 'height';
    BcListRowConstants.BOTTOM = 'bottom';
    return BcListRowConstants;
}(common_constants_1.BcCommonConstants));
exports.BcListRowConstants = BcListRowConstants;
var BcListRowAriaLabels = (function () {
    function BcListRowAriaLabels() {
    }
    BcListRowAriaLabels.FOR_BUTTON = 'button';
    BcListRowAriaLabels.FOR_CELL = 'cell';
    BcListRowAriaLabels.MAIN_ACTION = 'Acción principal';
    BcListRowAriaLabels.DATA_COLUMN = 'Columna de datos';
    BcListRowAriaLabels.CHECKBOX = 'Casilla de verificación';
    BcListRowAriaLabels.ROW_OPTIONS = 'Opciones de la fila';
    return BcListRowAriaLabels;
}());
exports.BcListRowAriaLabels = BcListRowAriaLabels;
var BcListRowQuerySelectors = (function () {
    function BcListRowQuerySelectors() {
    }
    BcListRowQuerySelectors.INPUT_TYPE_CHECKBOX = 'input[type=checkbox]';
    BcListRowQuerySelectors.INPUT_TYPE_RADIO = 'input[type=radio]';
    return BcListRowQuerySelectors;
}());
exports.BcListRowQuerySelectors = BcListRowQuerySelectors;
